import { render, staticRenderFns } from "./chart-top-product-container.vue?vue&type=template&id=3fbba47c&scoped=true&"
import script from "./chart-top-product-container.vue?vue&type=script&lang=js&"
export * from "./chart-top-product-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbba47c",
  null
  
)

export default component.exports